module.exports = __webpack_public_path__ + "img/event-propulse-balboa.83cc13a.jpg";